import styled, { css } from "styled-components";

export const StepperWrapper = styled.div`
  ${({ theme }) => css`
    .MuiTypography-body2 {
      font-size: 0.75rem;
      color: ${theme.colors.dark_background};
      font-weight: 500;
    }

    .MuiStepper-root.MuiStepper-vertical,
    .MuiStepper-root.MuiStepper-horizontal {
      background-color: transparent;
    }
  `}
`;

export const StepperWrapperHorizontal = styled(StepperWrapper)``;

export const StepperWrapperVertical = styled(StepperWrapper)`
  ${({ theme }) => css`
    @media (max-width: ${theme.breakpoints.medium}) {
      .MuiTypography-body2 {
        font-size: 1rem;
      }
    }
  `}
`;
